import "./index.css";
import Rows from "components/Rows";
import EditModal from "../ui/EditModal";
import React, { useState } from "react";
import { Form, Input, Rate } from "antd";

import type { TypeProfileInfo } from "BlueratePersonalSite/interface";

const REQUIRED = [{ required: true, message: "inputs must not be empty" }];

type TypeReviewsList = TypeProfileInfo.DTO["LandingPageSetUp"]["ReviewsList"];

interface TypeEditTestimonialProps<T = TypeReviewsList> {
  value?: T;
  onChange?(value: T): void;
}

/**
 * @name EditTestimonial 编辑 用户评价啥的
 */
const EditTestimonial: React.FC<TypeEditTestimonialProps> = ({
  value,
  onChange,
}) => {
  const [open, setOpen] = useState(false);

  const [form] = Form.useForm<{ ReviewsList: TypeReviewsList }>();

  /**
   * @name onSubmit “Save”
   * @description 表单验证符合规则的提交
   */
  async function onSubmit() {
    const values = await form.validateFields();
    onChange?.(values.ReviewsList);
    onOpen();
  }

  function onInsert() {
    const faqInfo = form.getFieldValue(["ReviewsList"]);
    faqInfo.push({});
    form.setFieldValue("ReviewsList", faqInfo);
  }

  function onOpen() {
    setOpen((b) => !b);
    if (open) {
      form.resetFields();
    } else {
      const ReviewsList = value?.length ? value : [{}];
      form.setFieldsValue({ ReviewsList });
    }
  }

  return (
    <>
      <img onClick={onOpen} src="/images/document-edit.svg" />
      <EditModal
        open={open}
        width={650}
        onOk={onSubmit}
        onCancel={onOpen}
        onInsert={onInsert}
        title="Edit Testimonial"
        description={`Customer feedback is crucial in helping borrowers understand the benefits of your services. By sharing your experiences, you can help borrowers make informed decisions.`}
      >
        <Form form={form} layout="vertical">
          <Form.List initialValue={[{}]} name="ReviewsList">
            {(fields, { remove }) =>
              fields.map((v) => (
                <EditModal.Item
                  key={v.key}
                  onDelete={() => remove(v.name)}
                  title={`Customer review (${v.name + 1})`}
                >
                  <Form.Item
                    label="Rating"
                    rules={REQUIRED}
                    initialValue={5}
                    layout="horizontal"
                    name={[v.name, "star"]}
                    className="website-edit-rate"
                  >
                    <Rate />
                  </Form.Item>

                  <Rows span={12}>
                    <Form.Item
                      rules={[
                        ...REQUIRED,
                        { max: 20, message: "No longer than 20 characters" },
                        {
                          pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
                          message: "Must not contain special symbols.",
                        },
                      ]}
                      label="First name"
                      name={[v.name, "firstname"]}
                    >
                      <Input allowClear placeholder="Please enter first name" />
                    </Form.Item>

                    <Form.Item
                      rules={[
                        ...REQUIRED,
                        { max: 20, message: "No longer than 20 characters" },
                        {
                          pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
                          message: "Must not contain special symbols.",
                        },
                      ]}
                      label="Last name"
                      name={[v.name, "lastname"]}
                    >
                      <Input allowClear placeholder="Please enter last name" />
                    </Form.Item>
                  </Rows>

                  <Form.Item
                    rules={REQUIRED}
                    label="Testimonial"
                    name={[v.name, "review"]}
                  >
                    <Input.TextArea
                      rows={3}
                      allowClear
                      placeholder="Please enter Answer"
                    />
                  </Form.Item>
                </EditModal.Item>
              ))
            }
          </Form.List>
        </Form>
      </EditModal>
    </>
  );
};

export default EditTestimonial;
